export function TextSqueezer({ children }) {
  return <div style={{ maxWidth: '800px' }}>{children}</div>
}
